import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-740766f7")

_pushScopeId("data-v-740766f7")
const _hoisted_1 = { class: "full-container" }
const _hoisted_2 = { class: "header-menu-container align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#212327",
  style: {"margin-right":"4px"}
}, [
  /*#__PURE__*/_createVNode("g", { "clip-path": "url(#clip0_14491_426)" }, [
    /*#__PURE__*/_createVNode("path", { d: "M11.776 1C9.424 1 7.552 2.928 7.552 5.264C7.552 7.056 8.704 9.08 9.688 10.464C10.2758 11.2946 10.9144 12.0881 11.6 12.84C11.648 12.888 11.688 12.928 11.776 12.928C11.8422 12.9169 11.9035 12.8863 11.952 12.84C12.352 12.44 13.104 11.536 13.864 10.464C14.84 9.072 16 7.056 16 5.264C16 2.928 14.088 1 11.776 1ZM11.776 7.816C10.352 7.816 9.2 6.648 9.2 5.216C9.2 3.784 10.352 2.616 11.776 2.616C13.2 2.616 14.352 3.784 14.352 5.216C14.352 6.648 13.2 7.816 11.776 7.816ZM7.648 11.672L1.248 10.952L2.184 7.768C2.20966 7.68069 2.26206 7.60363 2.33381 7.54766C2.40557 7.49169 2.49307 7.45963 2.584 7.456H7.336C7.55817 8.07222 7.82557 8.67118 8.136 9.248L7.648 11.672ZM6.752 15.8H0.44C0.371204 15.803 0.302777 15.7884 0.241185 15.7576C0.179593 15.7268 0.126871 15.6808 0.088 15.624C0 15.536 0 15.4 0 15.264L0.888 12.216L7.376 12.936L6.752 15.8ZM14.624 10.504L15.2 12.52L13.288 12.296C13.64 11.896 14 11.4 14.4 10.864C14.448 10.736 14.536 10.64 14.624 10.504ZM15.552 13.824L15.952 15.216C15.952 15.264 16 15.304 16 15.352C16.0001 15.4109 15.9886 15.4692 15.9662 15.5236C15.9437 15.578 15.9107 15.6275 15.8691 15.6691C15.8275 15.7107 15.778 15.7437 15.7236 15.7662C15.6692 15.7886 15.6109 15.8001 15.552 15.8H8.088L8.664 13.064L15.552 13.824Z" })
  ]),
  /*#__PURE__*/_createVNode("defs", null, [
    /*#__PURE__*/_createVNode("clipPath", { id: "clip0_14491_426" }, [
      /*#__PURE__*/_createVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "width40px" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "width60px" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "width60px" }, null, -1)
const _hoisted_8 = { class: "body-container" }
const _hoisted_9 = { class: "vertical-menu-container" }
const _hoisted_10 = { class: "flex1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select_list = _resolveComponent("select-list")
  const _component_text_popover = _resolveComponent("text-popover")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_horizontal = _resolveComponent("horizontal")
  const _component_vertical = _resolveComponent("vertical")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_password_dialog = _resolveComponent("password-dialog")
  const _component_billing_dialog = _resolveComponent("billing-dialog")
  const _component_link_site_dialog = _resolveComponent("link-site-dialog")
  const _component_link_succeed_dialog = _resolveComponent("link-succeed-dialog")
  const _component_document_dialog = _resolveComponent("document-dialog")
  const _component_import_face_tip = _resolveComponent("import-face-tip")
  const _component_emergency_action_dialog = _resolveComponent("emergency-action-dialog")
  const _component_password_update_reminder_dialog = _resolveComponent("password-update-reminder-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_horizontal, {
      onLogOut: _ctx.goBackLogin,
      "home-url": `/${_ctx.propertyBaseRouter}/${_ctx.propertySubRouter.home}`
    }, {
      default: _withId(() => [
        _createVNode("header", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_text_popover, {
            name: _ctx.activeCommunity.label,
            isShow: _ctx.controlPopVal['community'],
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideOtherPop(Boolean($event), 'community')))
          }, {
            default: _withId(() => [
              _createVNode(_component_select_list, {
                list: _ctx.communityList,
                active: _ctx.activeCommunity.ID,
                filterable: "",
                "clear-filter": _ctx.controlPopVal['community'],
                onChangeSelect: _ctx.changeCommunity
              }, null, 8, ["list", "active", "clear-filter", "onChangeSelect"])
            ]),
            _: 1
          }, 8, ["name", "isShow"]),
          _hoisted_4,
          (_ctx.community.ProjectType.value==='community'&&_ctx.community.isNew.value)
            ? (_openBlock(), _createBlock(_component_cus_button, {
                key: 0,
                onClick: _ctx.openEmergencyAction
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.EmergencyAction), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_text_popover, {
            name: _ctx.account,
            isShow: _ctx.controlPopVal['account'],
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideOtherPop(Boolean($event), 'account')))
          }, {
            default: _withId(() => [
              _createVNode(_component_select_list, {
                list: _ctx.userOperaList,
                onChangeSelect: _ctx.chooseOpera
              }, null, 8, ["list", "onChangeSelect"])
            ]),
            _: 1
          }, 8, ["name", "isShow"]),
          _hoisted_7,
          (_ctx.community.ProjectType.value==='community'&&_ctx.community.isNew.value)
            ? (_openBlock(), _createBlock(_component_el_badge, {
                key: 1,
                class: "badge-number",
                value: _ctx.community.alertCount.value,
                hidden: _ctx.community.alertCount.value===0,
                type: "danger"
              }, {
                default: _withId(() => [
                  _createVNode("i", {
                    class: "el-icon-my-miaoshatixing_icon alarm-icon",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toAlarm && _ctx.toAlarm(...args)))
                  })
                ]),
                _: 1
              }, 8, ["value", "hidden"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["onLogOut", "home-url"]),
    _createVNode("section", _hoisted_8, [
      _createVNode("aside", _hoisted_9, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withId(() => [
            _createVNode(_component_vertical, { menus: _ctx.menus }, null, 8, ["menus"])
          ]),
          _: 1
        })
      ]),
      _createVNode("section", _hoisted_10, [
        _createVNode(_component_router_view, {
          key: _ctx.$route.fullPath
        })
      ])
    ]),
    (_ctx.isShowPasswordDialog)
      ? (_openBlock(), _createBlock(_component_password_dialog, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowPasswordDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowBillingDialog)
      ? (_openBlock(), _createBlock(_component_billing_dialog, {
          key: 1,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowBillingDialog = false)),
          userType: "property"
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowLinkSiteDialog)
      ? (_openBlock(), _createBlock(_component_link_site_dialog, {
          key: 2,
          onSuccess: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowLinkSucceedDialog = true)),
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowLinkSiteDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowLinkSucceedDialog)
      ? (_openBlock(), _createBlock(_component_link_succeed_dialog, {
          key: 3,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowLinkSucceedDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowDocumentDialog)
      ? (_openBlock(), _createBlock(_component_document_dialog, {
          key: 4,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowDocumentDialog = false)),
          list: _ctx.fileList
        }, null, 8, ["list"]))
      : _createCommentVNode("", true),
    (_ctx.isShowImportFaceTip)
      ? (_openBlock(), _createBlock(_component_import_face_tip, {
          key: 5,
          "face-task-list": _ctx.dealImportDetails,
          onClose: _ctx.closeImportFaceTip
        }, null, 8, ["face-task-list", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_emergency_action_dialog, { ref: "emergencyActionDialogRef" }, null, 512),
    (_ctx.isShowPasswordUpdateReminder)
      ? (_openBlock(), _createBlock(_component_password_update_reminder_dialog, {
          key: 6,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowPasswordUpdateReminder = false)),
          onGoAndSet: _cache[11] || (_cache[11] = () => {
                _ctx.isShowPasswordDialog = true;
                _ctx.isShowPasswordUpdateReminder = false;
            })
        }))
      : _createCommentVNode("", true)
  ]))
})